import { Route, Routes } from 'react-router-dom'
import PaymentsPage from '../../pages/shared-pages/payments/PaymentsPage'
import PaymentDetailsPage from '../../pages/shared-pages/payments/PaymentDetailsPage'

export default function PaymentNav() {
  return (
    <Routes>

      <Route path="/" element={<PaymentsPage />} />
      <Route path="/details" element={<PaymentDetailsPage />} />

    </Routes>
  )
}
